/**
 * 用于收集页面中的模块数据
 * 为快速导航提供基础数据
 * 
 * @Author: Focci
 * @Date: 2023-08-11 09:00:46
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 09:00:46
 * 
 * eg:
 * 
 * <div data-modulename="名称", id="module-name" />
 * <div data-modulename="分类", id="module-catetory" />
 * 
 * options: [
 *   { label: '名称'}, value: 'module-name' },
 *   { label: '分类'}, value: 'module-catetory' },
 *   ...
 * ]
 */

import { forEach } from 'lodash-es'
import { useEffect, useState } from 'react'
import { isWindow } from '@lib/utils'

function getModuleOptionsCallback(selectors, setOptions) {
  return function getModuleOptions() {
    const els = document.querySelectorAll(selectors)
    const result = []
  
    forEach(els, (el) => {
      const label = el.dataset.modulename
      const value = el.getAttribute('id')
  
      if(label && value) {
        result.push({ label, value, el })
      }
    })
  
    return setOptions(result)
  }
}

function getCurrentItem(options, setValue) {
  return () => {
    let current = null

    for(let i = 0, len = options.length; i < len; i++) {
      const { el } = options[i]
      const { top } = el.getBoundingClientRect()
      
      if(top - 200 > 0) {
        break
      }

      current = options[i]
    }

    current && setValue(current.value)
  }
}

export default function useMutationModule(
  selectors = 'div[data-modulename]',
  container = null,
) {
  const [options, setOptions] = useState([])
  const [value, setValue] = useState()

  // 监听节点变化，更新导航数据
  useEffect(() => {
    let observer = new MutationObserver(
      getModuleOptionsCallback(selectors, setOptions)
    )

    if(isWindow) {
      observer.observe(
        window.document.documentElement, 
        { childList: true, attributes: true, subtree: true }
      )
    }

    return () => {
      observer.disconnect()
      observer = null
    }
  }, [selectors])

  // 设置当前选中项
  useEffect(() => {
    const target = container || (isWindow ? window : null)
    const callback = getCurrentItem(options, setValue)
    
    callback()
    target && target.addEventListener('scroll', callback, false)

    return () => {
      target && target.removeEventListener('scroll', callback, false)
    }
  }, [container, options])
  
  return {
    value,
    options
  }
}
